<template>
  <q-slide-item
    :right-color="removeIcon(items.orderItems).color"
    class="bg-responsive"
    data-test-id="cart-item"
    @right="resetSlide => $emit('delete', items.orderItems, resetSlide)"
    @click="!viewOnly && items.firstOrderItem.state === 'draft' && $emit('edit', items.lastOrderItem)"
  >
    <template
      v-if="!viewOnly && items.firstOrderItem.operative"
      #right
    >
      <q-icon
        left
        :name="removeIcon(items.orderItems).icon"
        @click.stop="resetSlide => $emit('delete', items.orderItems, resetSlide)"
      />
      {{ removeIcon(items.orderItems).label }}
    </template>

    <q-item
      v-if="items.firstOrderItem.itemOrderItem && items.firstOrderItem.itemOrderItem.item"
      class="q-px-sm justify-around"
      :class="`state-${items.firstOrderItem.state}`"
      :style="items.firstOrderItem.state !== 'draft' ? 'cursor: default;' : ''"
    >
      <q-item-section
        v-if="currentCircuit.posOptions.show_images_in_cart || !$register"
        top
        class="col column text-center q-mt-xs items-center"
        :style="{ 'max-width': isDrawer || $register || $q.screen.lt.sm ? '50px' : '100px' }"
        :avatar="!items.firstOrderItem.itemOrderItem.item.image"
      >
        <q-img
          v-if="items.firstOrderItem.itemOrderItem.item.image"
          :src="items.firstOrderItem.itemOrderItem.item.imageUrl"
          :style="`background-color: ${items.firstOrderItem.itemOrderItem.item.backgroundColor || '#444'}`"
        />
        <q-avatar
          v-else
          text-color="white"
          class="flex flex-center text-white text-center text-h5"
          :style="`background-color: ${items.firstOrderItem.itemOrderItem.item.color || '#444'}`"
        >
          {{ items.firstOrderItem.itemOrderItem.item.abbreviation && items.firstOrderItem.itemOrderItem.item.abbreviation[0] || items.firstOrderItem.itemOrderItem.item.name[0] }}
        </q-avatar>
      </q-item-section>

      <q-item-section class="col">
        <q-item-label
          :overline="$register"
          :class="{ 'text-uppercase': $register }"
        >
          {{ items.firstOrderItem.itemOrderItem.item.name }} /
          <component
            :is="$register ? 'em' : 'span'"
          >
            {{ items.firstOrderItem.itemOrderItem.itemVariation.name }}
          </component>
          <template v-if="$register">
            <span v-if="items.firstOrderItem.hasCustomPrice">
              / Custom Price
            </span>
            <span v-else-if="items.firstOrderItem.itemOrderItem.itemVariation.price">
              /
              <i18n-n
                :value="items.firstOrderItem.itemOrderItem.itemVariation.price"
                format="currency"
                scope="global"
              />
            </span>
          </template>
          <template v-else>
            <q-chip
              v-if="items.firstOrderItem.localVoucher"
              rounded
              dense
              :color="items.firstOrderItem.localVoucher.color"
              :text-color="buttonTextColor(items.firstOrderItem.localVoucher.color)"
              :size="isDrawer && $consumer ? 'sm' : 'md'"
              :removable="!viewOnly && items.firstOrderItem.localVoucher.canRemove"
              :label="items.firstOrderItem.localVoucher.label"
              @remove="$emit('remove-voucher', items)"
            />
            <q-chip
              v-if="items.firstOrderItem.discount && !items.firstOrderItem.itemPackage"
              rounded
              dense
              color="secondary"
              :text-color="buttonTextColor(currentSite.secondaryColor)"
              :size="isDrawer && $consumer ? 'sm' : 'md'"
              :label="items.firstOrderItem.discount.displayName"
              :removable="!viewOnly && items.firstOrderItem.state !== 'paid' && !items.firstOrderItem.discount.orderItemPackageOnly"
              @remove="order.removeDiscount(items.firstOrderItem)"
            />
            <q-chip
              v-if="items.firstOrderItem.itemPackage"
              rounded
              dense
              color="secondary"
              :text-color="buttonTextColor(currentSite.secondaryColor)"
              :size="isDrawer && $consumer ? 'sm' : 'md'"
              :label="items.firstOrderItem.itemPackage.name"
              :removable="false"
            />
          </template>
        </q-item-label>
        <q-item-label>
          <component
            :is="$register ? 'div' : 'span'"
            v-for="itemModifier in items.firstOrderItem.itemOrderItem.itemModifiers.data"
            :key="itemModifier.id"
            :class="$register ? undefined : 'q-pr-sm text-responsive-grey-7'"
          >
            {{ itemModifier.modifierSet.name }} - {{ itemModifier.modifier.name }}
            <span v-if="itemModifier.price">
              (<i18n-n
                :value="itemModifier.price"
                format="currency"
                scope="global"
              />)</span>
          </component>
        </q-item-label>
        <q-item-label
          v-if="items.firstOrderItem.note"
          overline
        >
          <em> Note: </em>
          {{ items.firstOrderItem.note }}
        </q-item-label>
        <q-item-label
          v-if="$register"
          overline
        >
          <q-chip
            v-if="items.firstOrderItem.localVoucher"
            square
            dense
            :color="items.firstOrderItem.localVoucher.color"
            :text-color="buttonTextColor(items.firstOrderItem.localVoucher.color)"
            size="sm"
            :removable="!viewOnly && items.firstOrderItem.localVoucher.canRemove"
            :label="items.firstOrderItem.localVoucher.label"
            @remove="$emit('remove-voucher', items)"
          />
          <q-chip
            v-if="items.firstOrderItem.discount && !items.firstOrderItem.itemPackage"
            square
            dense
            color="secondary"
            text-color="white"
            size="sm"
            :label="items.firstOrderItem.discount.displayName"
            :removable="!viewOnly && items.firstOrderItem.state !== 'paid' && !items.firstOrderItem.discount.orderItemPackageOnly"
            @remove="order.removeDiscount(items.firstOrderItem)"
          />
          <q-chip
            v-if="items.firstOrderItem.itemPackage"
            square
            dense
            color="secondary"
            text-color="white"
            size="sm"
            :label="items.firstOrderItem.itemPackage.name"
            :removable="!$_.isNil(order.packageWorker)"
            @remove="order.excludePackageFromOrderItem(items.firstOrderItem)"
          />
          <q-chip
            v-if="items.firstOrderItem.hasDueTime && (items.firstOrderItem.hasDueTime !== order.hasDueTime || items.firstOrderItem.formattedDueTime !== order.formattedDueTime)"
            icon="access_time"
            dense
            size="sm"
            square
            :label="items.firstOrderItem.formattedDueTime"
          />
          <q-chip
            v-if="items.firstOrderItem.deliveryTypeName"
            dense
            size="sm"
            square
          >
            {{ $_.startCase(items.firstOrderItem.deliveryTypeName) }}
          </q-chip>
          <q-chip
            v-if="items.firstOrderItem.deliveryType === DELIVERY_TYPE_OPTIONS.COLLECT_FROM_REGISTER && !$_.isNil(items.firstOrderItem.collectedAt)"
            dense
            size="sm"
            square
          >
            <template v-if="!$_.isNil(items.firstOrderItem.collectedRegisterStation)">
              {{ `${$t('cart.collectedAt')} ${$_.startCase(items.firstOrderItem.collectedRegisterStation.name)} (${$d(currentSite.inSiteTime(items.firstOrderItem.collectedAt), 'shortTime')})` }}
            </template>
            <template v-else>
              {{ `${$t('cart.collectedAt')} ${$d(currentSite.inSiteTime(items.firstOrderItem.collectedAt), 'shortTime')}` }}
            </template>
          </q-chip>
          <q-item-label
            v-if="items.firstOrderItem && items.firstOrderItem.errors"
            class="text-negative"
          >
            {{ $_.startCase(items.firstOrderItem.errors) }}
          </q-item-label>
          <q-chip
            v-if="(items.firstOrderItem.deliveryLocation || items.firstOrderItem.defaultDeliveryLocation)"
            dense
            size="sm"
            square
          >
            {{ (items.firstOrderItem.deliveryLocation || items.firstOrderItem.defaultDeliveryLocation) }}
          </q-chip>
          <!-- TODO Handle when we are using defaultDeliveryPositions -->
          <q-chip
            v-if="items.firstOrderItem.displayDeliveryPositions.length"
            dense
            size="sm"
            square
          >
            {{ items.firstOrderItem.displayDeliveryPositions.join(', ') }}
          </q-chip>
        </q-item-label>
        <q-item-section
          v-if="!$register"
          class="col-auto column q-mt-xs"
        >
          <price
            :item="items"
            color="responsive"
          />
        </q-item-section>
        <q-item-section
          v-if="!$register && items.firstOrderItem && items.firstOrderItem.errors"
          class="col-auto column q-mt-xs text-negative"
        >
          {{ $_.startCase(items.firstOrderItem.errors) }}
        </q-item-section>
        <q-item-section
          v-if="!viewOnly && !$register"
          class="col-auto justify-end items-end"
        >
          <div class="row q-gutter-x-xs">
            <q-btn
              v-if="items.count < 2"
              class="col-auto"
              :class="{ 'q-px-xs': isDrawer }"
              icon="fal fa-trash-can"
              color="responsive-grey-2"
              text-color="responsive"
              :dense="isDrawer && $consumer"
              round
              :size="isDrawer && $consumer ? 'sm': 'md'"
              @click.stop="resetSlide => $emit('delete', items.orderItems, resetSlide)"
            >
              <q-tooltip>Click or swipe to remove this item</q-tooltip>
            </q-btn>
            <q-item-section>
              <div class="row justify-start items-center">
                <q-btn
                  v-if="items.firstOrderItem.state === 'draft' && items.count > 1"
                  :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
                  class="col-auto"
                  icon="fal fa-minus"
                  :size="isDrawer && $consumer ? 'sm': 'md'"
                  round
                  color="responsive-grey-2"
                  text-color="responsive"
                  :dense="isDrawer && $consumer"
                  @click.stop="$emit('remove', items.firstOrderItem)"
                />
                <div
                  v-if="items.count"
                  class="col-auto text-center q-px-sm"
                  :class="isDrawer ? 'q-py-xs' : 'q-py-sm'"
                  :style="{ 'line-height': $q.platform.is.ios ? '2' : undefined }"
                >
                  {{ items.count }}
                </div>
                <q-btn
                  class="col-auto"
                  :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
                  icon="fal fa-plus"
                  round
                  color="responsive-grey-2"
                  text-color="responsive"
                  :size="isDrawer && $consumer ? 'sm': 'md'"
                  :dense="isDrawer && $consumer"
                  @mousedown="$emit('touch-hold', true, items.firstOrderItem)"
                  @touchstart="$emit('touch-hold', true, items.firstOrderItem)"
                  @touchleave="$emit('touch-hold', false, items.firstOrderItem)"
                  @touchcancel="$emit('touch-hold', false, items.firstOrderItem)"
                  @touchend="$emit('touch-hold', false, items.firstOrderItem)"
                  @mouseup="$emit('touch-hold', false, items.firstOrderItem)"
                  @mouseout="$emit('touch-hold', false, items.firstOrderItem)"
                  @click.stop="(event) => !event.qKeyEvent && $emit('add', items.firstOrderItem)"
                />
              </div>
            </q-item-section>
          </div>
        </q-item-section>
      </q-item-section>
      <template v-if="($register && !viewOnly && items.firstOrderItem.requiresPrinting) || (items.firstOrderItem.placed || items.firstOrderItem.state === 'voided')">
        <q-item-section
          v-if="$register && !viewOnly && items.firstOrderItem.requiresPrinting"
          class="col-auto"
        >
          <fire-button
            :order-items="items.orderItems"
            :order="order"
            @place-order="type => $emit('place-order', type)"
          />
        </q-item-section>
        <q-item-section
          v-if="items.firstOrderItem.placed || items.firstOrderItem.state === 'voided'"
          class="col-auto"
        >
          <q-icon
            :name="items.firstOrderItem.state === 'paid' ? 'paid' : 'lock'"
            color="grey"
          />
        </q-item-section>
      </template>
      <template v-if="$register">
        <q-item-section
          class="col-auto column"
        >
          <price
            :item="items"
            color="responsive"
          />
        </q-item-section>
        <q-item-section
          v-if="!viewOnly"
          class="col-auto column reverse"
        >
          <q-btn
            v-if="items.firstOrderItem.state === 'draft'"
            :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
            class="col-auto"
            icon="fal fa-minus"
            dense
            square
            outline
            :size="isDrawer ? 'xs': undefined"
            @click.stop="$emit('remove', items.firstOrderItem)"
          />
          <div
            v-if="items.count"
            class="col-auto text-center q-px-sm"
            :class="isDrawer ? undefined : 'q-py-xs'"
            :style="{ 'line-height': $q.platform.is.ios ? '2' : undefined }"
          >
            {{ items.count }}
          </div>
          <q-btn
            class="col-auto"
            :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
            icon="fal fa-plus"
            dense
            square
            outline
            :size="isDrawer ? 'xs': undefined"
            @mousedown="$emit('touch-hold', true, items.firstOrderItem)"
            @touchstart="$emit('touch-hold', true, items.firstOrderItem)"
            @touchleave="$emit('touch-hold', false, items.firstOrderItem)"
            @touchcancel="$emit('touch-hold', false, items.firstOrderItem)"
            @touchend="$emit('touch-hold', false, items.firstOrderItem)"
            @mouseup="$emit('touch-hold', false, items.firstOrderItem)"
            @mouseout="$emit('touch-hold', false, items.firstOrderItem)"
            @click.stop="(event) => !event.qKeyEvent && !touchHoldId && $emit('add', items.firstOrderItem)"
          />
        </q-item-section>
      </template>
    </q-item>
  </q-slide-item>
</template>

<script>
import { DELIVERY_TYPE_OPTIONS } from 'src/models/delivery-type/DeliveryType'
import Price from 'src/modules/register/components/cart/Price'
import FireButton from 'src/modules/register/components/FireButton'
export default {
  name: 'ItemsItem',
  configuration: ['currentSite', 'currentCircuit'],
  components: {
    Price,
    FireButton
  },
  inject: ['order'],
  props: {
    items: {
      type: Object,
      required: true,
      default: null
    },
    isDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultOpened: {
      type: Boolean,
      required: false,
      default: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['delete', 'edit', 'remove-voucher', 'remove', 'touch-hold', 'add', 'place-order'],
  created () {
    _.extend(this, { DELIVERY_TYPE_OPTIONS })
  },
  methods: {
    removeIcon (orderItems) {
      const orderItem = orderItems[0]
      if (orderItem.state === 'draft') {
        return {
          icon: 'delete',
          color: 'warning',
          label: 'Remove' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed && orderItem.pickPrepPrintingStatus === 'success') {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed) {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else {
        return {}
      }
    },
    buttonTextColor (color) {
      // when return hex code
      if (color.startsWith('#')) return this.$isColorDark(color) ? 'white' : 'black'
      // when return value from colorOptions
      const colorHex = this.$getSiteColorHex(this.currentSite, color)
      if (!colorHex) return null
      return this.$isColorDark(colorHex) ? 'white' : 'black'
    }
  }
}

</script>
<style lang="scss" scoped>
.q-btn--round.col-auto {
    padding: 0;
    min-height: 3em;
    min-width: 3em
  }
</style>
